var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',{staticClass:"page"},[_c('font',{staticClass:"index-title"},[_vm._v("欢迎访问天天有网球后台管理系统")]),_c('img',{attrs:{"src":require("./image/index-footer.png"),"alt":"logo"}}),_c('template',{slot:"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }